import {LandIconInfoMarketTile} from '#/components/market-data/land-icon-info-market-tile';
import {useQueryNavigationActions} from '#/hooks/use-query-navigation-actions';
import {ComponentProps, FunctionComponent} from 'react';

export const TrendingMarketItemButton: FunctionComponent<ComponentProps<typeof LandIconInfoMarketTile>> = ({
  className,
  land,
  landMarketInfo,
  ...rest
}) => {
  const {
    actionMenu: {openInformation},
  } = useQueryNavigationActions();

  const onClick = () => {
    openInformation(land);
  };

  return (
    <button onClick={onClick} className={`block cursor-pointer group/item ${className}`}>
      <LandIconInfoMarketTile
        className='group-hover/item:scale-105 transition-transform duration-300'
        land={land}
        landMarketInfo={landMarketInfo}
        {...rest}
      />
    </button>
  );
};
